/**
 * DateRangeFilter — shared date range picker used by Sales and Purchase log pages.
 *
 * Props:
 *   dateRange   { start: 'YYYY-MM-DD', end: 'YYYY-MM-DD' }
 *   onChange    (newRange) => void
 */
import React from 'react';

const today = () => new Date().toISOString().split('T')[0];

const SHORTCUTS = [
  {
    label: 'Today',
    fn: () => { const d = today(); return { start: d, end: d }; },
  },
  {
    label: 'This Week',
    fn: () => {
      const now = new Date();
      const mon = new Date(now);
      mon.setDate(now.getDate() - now.getDay() + 1);
      return { start: mon.toISOString().split('T')[0], end: today() };
    },
  },
  {
    label: 'This Month',
    fn: () => {
      const now = new Date();
      return {
        start: new Date(now.getFullYear(), now.getMonth(), 1).toISOString().split('T')[0],
        end: today(),
      };
    },
  },
];

const DateRangeFilter = ({ dateRange, onChange }) => (
  <div className="flex flex-wrap items-center gap-3">
    <span className="text-xs font-semibold text-slate-500 uppercase tracking-wide">Range</span>
    <div className="flex items-center gap-1.5">
      <label className="text-xs text-slate-400">From</label>
      <input
        type="date"
        value={dateRange.start}
        onChange={e => onChange({ ...dateRange, start: e.target.value })}
        className="border border-slate-200 rounded-md px-2 py-1 text-xs focus:outline-none focus:ring-2 focus:ring-primary"
      />
    </div>
    <div className="flex items-center gap-1.5">
      <label className="text-xs text-slate-400">To</label>
      <input
        type="date"
        value={dateRange.end}
        onChange={e => onChange({ ...dateRange, end: e.target.value })}
        className="border border-slate-200 rounded-md px-2 py-1 text-xs focus:outline-none focus:ring-2 focus:ring-primary"
      />
    </div>
    {SHORTCUTS.map(s => (
      <button
        key={s.label}
        onClick={() => onChange(s.fn())}
        className="px-2.5 py-1 rounded-full text-xs font-medium bg-slate-100 text-slate-600 hover:bg-slate-200 transition-colors"
      >
        {s.label}
      </button>
    ))}
  </div>
);

export default DateRangeFilter;
